import { Box, Container, Grid, Paper, Typography } from "@mui/material";
import { useCallback, useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ConfirmProvider } from "material-ui-confirm";
import Dashboard from "./Dashboard";
import SideMenu from "./components/SideMenu";
import Perfis from "./Perfis";
import Usuarios from "./Usuarios";
import Fluxos from "./Fluxos";
import IntegracaoWhatsapp from "./IntegracaoWhatsapp";
import Mensagens from "./Mensagens";
import CopyNorteConfig from "./CopyNorte";
import FormulariosDyn from "./FormulariosDyn";
import PermissionGuard from "../../components/PermissionGuard";

export default function Configuracoes() {

    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const [configSelecionada, setConfigSelecionada] = useState<TConfigSelect>(params.get('menu') as TConfigSelect || "Dashboard")

    //Funções Manipuladoras
    const handleSelectItemConfig = useCallback((config: TConfigSelect) => {
        setConfigSelecionada(config)
        navigate(`/configuracoes?menu=${config}`);
    }, [navigate])
    //

    //Valores importantes
    const renderContent = useMemo(() => {
        if (configSelecionada === "Dashboard") {
            return <Dashboard />
        }
        if (configSelecionada === "Perfis") {
            return <Perfis />
        }
        if (configSelecionada === "Usuários") {
            return <Usuarios />
        }
        if (configSelecionada === "Formulários") {
            return <FormulariosDyn />
        }
        if (configSelecionada === "Fluxos") {
            return <Fluxos />
        }
        if (configSelecionada === "Integração WhatsApp") {
            return <IntegracaoWhatsapp />
        }
        if (configSelecionada === "Mensagens") {
            return <Mensagens />
        }
        if (configSelecionada === "Copy Norte") {
            return <CopyNorteConfig />
        }
    }, [configSelecionada])
    //

    return (
        <>
            <PermissionGuard permissionId="configuracoes.dashboard">

                <Container sx={{ my: 4 }}>
                    <Typography textAlign="center" variant="h5">Configurações gerais</Typography>

                    <Grid container spacing={2} mt={1}>
                        <Grid size={{xs: 12, md: 4}}>
                            <Box component={Paper} p={2}>
                                <SideMenu
                                    select={configSelecionada}
                                    handleSelect={(item) => handleSelectItemConfig(item)}
                                />
                            </Box>
                        </Grid>

                        <Grid size={{xs: 12, md: 8}}>
                            <Box component={Paper} p={2}>
                                <ConfirmProvider defaultOptions={{
                                    title: 'Excluir item',
                                    cancellationText: "Cancelar",
                                    confirmationText: "Excluir",
                                    confirmationButtonProps: { variant: 'contained', color: 'error' }
                                }}>
                                    {renderContent}
                                </ConfirmProvider>
                            </Box>
                        </Grid>
                    </Grid>
                </Container>
            </PermissionGuard>
        </>
    )
}

export type TConfigSelect = "Dashboard" 
| "Usuários" 
| "Perfis" 
| "Fluxos" 
| "Integração WhatsApp" 
| "Mensagens" 
| "Copy Norte" 
| "Formulários" 
| "Configurações"

export type TConfigModalState = {
    [key in TConfigSelect]?: boolean;
};